import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const VehicleBlock = ({ imgSrc, price, title, link, onBook, seats }) => (
    <div className="col-lg-4 col-md-6 m-b30 wow fadeInDown" data-wow-delay="0.2">
        <div className="twm-vehicle-fleet-bx twm-custom-grid-3">
            <div className="twm-media">
                <div className="twm-media-pic">
                    <img src={imgSrc} alt="image" />
                </div>
            </div>
            <div className="twm-vehicle-fleet-content">
                <h3 className="twm-v-title"><a href={link}>{title}</a></h3>
                <ul className="twm-vehicle-facility">
                    <li><span><img src="images/icons/car-seat.png" alt="Image" /></span>{seats} Seat</li>
                    <li><span><img src="images/icons/bag.png" alt="Image" /></span>4 Bags</li>
                    <li><span><img src="images/icons/car.png" alt="Image" /></span>4 Suv</li>
                </ul>
                <ul className="twm-vehicle-fuel-type">
                    <li>Petrol</li>
                    <li><del>Diesel</del></li>
                    <li><del>Electric</del></li>
                </ul>
                <div className='text-center py-3'>
                    <button className="btn-book px-3 p-2 rounded-5 butun text-white" onClick={() => onBook(title)}>Book Now</button>
                </div>
            </div>
        </div>
    </div>
);

const Booking = () => {
    const [bookingMessage, setBookingMessage] = useState('');

    const vehicles = [
        { imgSrc: '/images/booking/1.jpg', price: 800, title: 'TOYOTA ETIOS', link: 'our-fleet', seats: 4 },
        { imgSrc: '/images/booking/2.jpg', price: 800, title: 'ERITGA', link: 'our-fleet', seats: 7 },
        { imgSrc: '/images/booking/3.jpg', price: 800, title: 'SCORPIO', link: 'our-fleet', seats: 7 },
        { imgSrc: '/images/booking/4.jpg', price: 800, title: 'SWIFT DESIRE', link: 'our-fleet', seats: 4 },
        { imgSrc: '/images/booking/5.jpg', price: 800, title: 'AURA', link: 'our-fleet', seats: 5 },
        { imgSrc: '/images/booking/6.jpg', price: 800, title: 'INNOVA CRYSTA', link: 'our-fleet', seats: 7 },
        { imgSrc: '/images/booking/7.jpg', price: 800, title: 'AUDI', link: 'our-fleet', seats: 4 },
        { imgSrc: '/images/booking/8.jpg', price: 800, title: 'TEMPO TRAVELLER', link: 'our-fleet', seats: 13 },
        { imgSrc: '/images/booking/9.jpg', price: 800, title: 'MINI BUS', link: 'our-fleet', seats: 16 },
        { imgSrc: '/images/booking/10.jpg', price: 800, title: 'TAVERA', link: 'our-fleet', seats: 7 },
        { imgSrc: '/images/booking/11.jpg', price: 800, title: 'KIA Carens', link: 'our-fleet', seats: 6 },
        { imgSrc: '/images/booking/12.jpg', price: 800, title: 'Honda City', link: 'our-fleet', seats: 5 },
        { imgSrc: '/images/booking/16.jpg', price: 800, title: 'INNOVA', link: 'our-fleet', seats: 7 },
        { imgSrc: '/images/booking/14.jpg', price: 800, title: 'Amaze', link: 'our-fleet', seats: 5 },
        { imgSrc: '/images/booking/15.jpg', price: 800, title: 'Toyota Corolla', link: 'our-fleet', seats: 5 },
    ];

    const handleBooking = (vehicleTitle) => {
        const phoneNumber = '8624029699'; 
        const message = `Hi, I would like to proceed with booking the ${vehicleTitle} for rent. Please confirm the availability. Looking forward to your confirmation and further details to complete the booking process.`;
        const encodedMessage = encodeURIComponent(message);
        window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
    };

    return (
        <div>
            <Helmet>
                <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
                <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
                <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
                <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
                <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
                <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="AB Ghule Cabs" />
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "LocalBusiness",
                            "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
                            description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "Pune, Maharashtra",
                                "addressLocality": "Pune",
                                "addressRegion": "Maharashtra",
                                "postalCode": "411001",
                                "addressCountry": "IN"
                            },
                            "telephone": "+91-8624029699",
                            "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
                            "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
                            "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
                            "priceRange": "₹1500 - ₹5000",
                            "offers": {
                                "@type": "Offer",
                                "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
                                "priceCurrency": "INR",
                                "price": "1500",
                                "priceValidUntil": "2024-12-31"
                            },
                            "aggregateRating": {
                                "@type": "AggregateRating",
                                "ratingValue": "4.8",
                                "reviewCount": "1500"
                            },
                            "review": [
                                {
                                    "@type": "Review",
                                    "author": {
                                        "@type": "Person",
                                        "name": "Sneha Kulkarni"
                                    },
                                    "datePublished": "2024-12-22",
                                    "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
                                },
                                {
                                    "@type": "Review",
                                    "author": {
                                        "@type": "Person",
                                        "name": "Vishal Sharma"
                                    },
                                    "datePublished": "2024-12-18",
                                    "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
                                }
                            ],
                            "serviceArea": {
                                "@type": "Place",
                                "name": "Pune and Mumbai",
                                "geo": {
                                    "@type": "GeoCoordinates",
                                    "latitude": "18.5204",
                                    "longitude": "73.8567"
                                }
                            },
                            "availableChannel": {
                                "@type": "ServiceChannel",
                                "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
                            },
                            "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
                        }
                    `}
                </script>
            </Helmet>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>Booking</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="section-full p-t150 p-b120 site-bg-white twm-cars-section-wrap pt-5">
                <div className="container">
                    <div className="section-content">
                        <div className="twm-cars-section m-b30">
                            <div className="row">
                                {vehicles.map((vehicle, index) => (
                                    <VehicleBlock 
                                        key={index} 
                                        imgSrc={vehicle.imgSrc} 
                                        title={vehicle.title} 
                                        onBook={handleBooking} 
                                        seats={vehicle.seats} 
                                    />
                                ))}
                            </div>
                        </div>
                        {bookingMessage && (
                            <div className="booking-message">
                                <p>{bookingMessage}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Booking;